import { datadogLogs } from '@datadog/browser-logs';

function init(): void {
  datadogLogs.init({
    clientToken: 'pubdfe19d931785ce4f7ea6f1a6ebeab2fb',
    site: 'datadoghq.eu',
    service: 'game-experience-front',
    env: process.env.DATADOG_ENV,
    forwardErrorsToLogs: false,
    forwardConsoleLogs: [],
    sessionSampleRate: 100,
  });
}
export { init, datadogLogs };
